module.exports = __webpack_public_path__ + "img/ep3-1.35e05704.png";